import AdminFeedbackForm from "./AdminFeedbackForm";
import Footer from "../../components/common/Footer";
import "../../assets/css/feedbackPage.css";
import AdminNavbar from "../AdminNavbar";
import AdminFeedbackResponses from "./AdminFeedbackResponses";

function AdminFeedbackPage() {

    return (

        <section className="customer-feedback-page">

            <AdminNavbar />

            {/*=========================================================
                            HERO SECTION
            =========================================================*/}

            <section className="customer-feedback-hero">

    <div className="customer-feedback-hero-content">

        <span className="customer-feedback-badge">
            STORY LINE STUDIOS
        </span>

        <h1>Client Feedback</h1>

        <div className="customer-feedback-line"></div>

        <p>
            Discover heartfelt words from our wonderful clients who trusted
            Story Line Studios to capture their unforgettable moments with
            timeless elegance, cinematic storytelling, and exceptional quality.
        </p>

    </div>

</section>
         
            {/*=========================================================
                            CONTENT
            =========================================================*/}

            <section className="customer-feedback-container">

                <div className="customer-feedback-form-wrapper">

                    <AdminFeedbackForm />

                </div>

                <div className="customer-feedback-list-wrapper">

                    <AdminFeedbackResponses />

                </div>

            </section>

            <Footer />

        </section>

    );

}

export default AdminFeedbackPage;